/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  OutlinedInput,
  Paper,
  Slide,
  Typography,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import { Field, Form, Formik } from "formik";
import AppButton from "./AppButton";
import {
  connectBank,
  getFormValues,
  getPockytBankFormData,
  getPockytConnectedBanks,
  showMessageBar,
} from "../store/actions";
import { useDispatch, useSelector } from "react-redux";
import AppScreenLoader from "./AppScreenLoader";
import * as yup from "yup";
import { fetchVendorStatus, logEvent, setFiatBankDetails } from "../store/api";
import { SHOW_MESSAGE } from "../store/actions/actionTypes";
import { ACTIVITY_STATUS, BANK_MODE, MESSAGE_BAR_TYPES, TRANSFER_MODE } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { AppDatePicker } from "./AppDatePicker";
import moment from "moment";
import { EVENTS } from "../utils/events";
import { getCustomErrorMessage, parseErrorMessage, replaceLabels, toValidationRegExp } from "../utils";
import ImageUploader from "./AppImageUpload";
import AppPopupWindow from "./AppPopupWindow";
import AppPreviewFormData from "./AppPreviewFormData";
import { getFormAttributesSelector, getFromValueSelector } from "../utils/selectorHelpers";
import AppSearchSelect from "./AppSearchSelect";
import { ArrowOutward } from "@mui/icons-material";

export default function PaymentForm({ setActive, currency, country, mode, setBank, setIsConflict, submitFlag = false, fiatOption, destinationRecord }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isSmallMobile = useMediaQuery('(max-width:480px)');
  const bankForm = useSelector(getFormAttributesSelector);
  const formValues = useSelector(getFromValueSelector);
  const [displayForm, setDisplayForm] = useState(null);
  const [preview, setPreview] = useState(false);
  const bankToReplace = useSelector(({ transfer }) => transfer.bankToReplace);
  const [validation, setValidation] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [showTNC, setShowTNC] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [saveResponse, setSaveResponse] = useState(null);
  const [customErrors, setCustomErrors] = useState(null);
  const [kycNeeded, setKYCNeeded] = useState(null);
  const [refetchingKyc, setRefetchingKyc] = useState(false);
  const [vendorStatus, setVendorStatus] = useState(null)
  const [loading, setLoading] = useState(false);
  const containerRef = useRef();
  const navigate = useNavigate();
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth', // or 'auto'
      });
    }
  }, [preview]);
  const getValues = () => {
    let obj = {};
    const validations = {};
    Object.keys(bankForm || {}).forEach((key) => {
      const fields = bankForm[key];
      fields.forEach((field) => {

        if (field.name === "bankCountry" || field.name === "country") {
          field.isEditable = false;
          field.value = country.iso2;
        }
        if (field.name === 'bankAccountPurpose') {
          field.value = field?.value ? field?.value?.toUpperCase() : '';
          field.regex = null;
        }
        if (field.name === 'CardExpiration') {
          field.type = 'date-month'
        }

        // if (field.name === 'bankAccountPurpose' && !field.value) {
        //   field.value = field?.acceptedValues?.[0]?.value || field?.acceptedValues?.[0];
        // }

        // if (field.name === 'bankAccountNumberType' && !field.value) {
        //   field.value = field?.acceptedValues?.[0]?.value || field?.acceptedValues?.[0];
        // }
        if (field.acceptedValues?.length > 0 && !field.value) {
          field.value = field?.acceptedValues?.[0]?.value || field?.acceptedValues?.[0];
        }

        // Set default value for select and radio fields that don't have a value
        if ((field.type === 'select' || field.type === 'radio') && !field.value && field?.acceptedValues?.length > 0) {
          field.value = field.acceptedValues[0]?.value || field.acceptedValues[0];
        }

        if (field.name === 'poaIssuingCountry' || field.name === 'govtIdIssuingCountry') {
          field.value = country.iso2;
        }
        if (field?.isEditable) {
          let schema = yup.string();
          if (field.minLength) {
            schema = schema.min(
              field.minLength,
              t("Min length is ") + field.minLength
            );
          }
          if (field.maxLength) {
            schema = schema.max(
              field.maxLength,
              t("Max length is ") + field.maxLength
            );
          }
          if (field.regex && typeof field.regex === "string") {
            const regex = toValidationRegExp(field.regex);
            if (regex) {
              schema = schema.matches(regex, t("validation.invalidFormat"));
            }
          }
          if (field.isRequired) {
            schema = schema.required("This field is required");
          }
          validations[field.name + key] = schema;
        }
        obj = { ...obj, [field.name + key]: field?.value };
      });
    });
    setValidation(validations);
    return obj;
  };

  const getBankFormData = () => {
    const obj1 = {};  // to store the display values
    let verification = false;
    Object.keys(bankForm || {}).forEach((key) => {
      const fields = bankForm[key];
      const obj = fields.filter((field) => {
        if (field.name === 'IDSelfieCollection') {
          verification = true;
          setKYCNeeded(field?.link);
        }
        const fields = formValues?.fields;
        if (fields?.[field.name] && field?.acceptedValues?.length <= 0) {
          // eslint-disable-next-line eqeqeq
          field.acceptedValues = fields?.[field.name];
        }
        if (field?.isEditable) {
          // set form display values
          return true
        } else {
          // set preview data
          return false;
        }
      });
      obj1[key] = obj;
    });
    if (verification) {
      Object.keys(bankForm || {}).forEach((key) => {
        const fields = bankForm[key];
        const obj = fields.filter((field) => {
          if (field.name === 'IDSelfieCollection') {
            return true;
          }
          return false;
        });
        obj1[key] = obj;
      });
    }
    setDisplayForm(obj1)
  }
  const [initialValues, setInititalValues] = useState(() => getValues());
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  useEffect(() => {
    const values = getValues();
    setInititalValues(values);
    getBankFormData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankForm]);
  const handleFetchFormError = useCallback((err) => {
    setRefetchingKyc(false);
    if (err?.response?.data?.data) {
      // check if its a conflict
      if (err?.response?.data?.data?.isConflict) {
        setIsConflict(true)
        setLoading(false);
      } else {
        dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err.message))
      }
    }
  }, [dispatch, setIsConflict, setLoading]);

  const handleSuccessFormFetch = useCallback(() => {
    setRefetchingKyc(false);
  }, []);
  const vendorVeriffStats = useCallback(async () => {
    const response = await fetchVendorStatus();
    setVendorStatus(response?.result)
  }, []);
  useEffect(() => {
    dispatch(getPockytBankFormData(currency.id, country.iso2, destinationRecord?.destinationRecordId, handleSuccessFormFetch, handleFetchFormError));
    dispatch(getFormValues());
    vendorVeriffStats();
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_FORM_LOADED,
      activity: EVENTS.BANK_TRANSFER.BANK_FORM_LOADED,
      meta: {
        country,
        currency,
        fiatService,
        mode
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleFormSubmit = async (data, { setErrors }) => {
    try {
      setInititalValues(data);
      setLoading(true);
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);
      const payload = {};
      const attributes = {};
      Object.keys(bankForm || {}).forEach((key) => {
        const fields = bankForm[key];
        fields.forEach((field) => {
          if (data[field.name + key]) {
            if (field.name === 'dateOfBirth' && moment(data[field.name + key]).isValid()) {
              payload[key] = {
                ...payload[key],
                [field.name]: moment(data[field.name + key] || '').format('YYYY-MM-DD')
              }
            } else
              payload[key] = {
                ...payload[key],
                [field.name]: data[field.name + key],
              };
            if (field?.attr) {
              attributes[field.name] = field?.attr;
            }
          }
        });
      });
      if (fiatOption && Object.keys(fiatOption).length > 0) {
        // in case of masspay destination record should be sent
        payload.paymentMethod = destinationRecord?.id || fiatOption.caption;
      }
      payload.currency = currency.id;
      payload.country = country.iso2;
      if (destinationRecord && destinationRecord.destinationRecordId) {
        payload.destinationRecordId = destinationRecord.destinationRecordId;
      }
      if (bankToReplace?.accountTag) {
        payload.bankToReplace = bankToReplace
      }
      if (Object.keys(attributes).length) {
        payload.attributes = attributes;
      }
      const resp = await setFiatBankDetails(payload, payload.currency, payload.country);
      // dispatch(getPockytConnectedBanks());
      setIsComplete(true);
      setShowTNC(!!resp?.result?.account?.tosLink);
      setIsSubmitting(false);
      setSaveResponse(resp?.result)
      if (resp?.result?.account?.status === 1) {
        logEvent({
          current: EVENTS.BANK_TRANSFER.BANK_FORM_SAVED,
          activity: EVENTS.BANK_TRANSFER.BANK_FORM_SAVED,
          meta: {
            country,
            currency,
            fiatService,
            mode,
          }
        });
        // it should be in order
        setBank(resp?.result?.account);
        setActive(4, 'summary');
        dispatch(connectBank(false));
        if (mode === BANK_MODE) {
          dispatch(getPockytConnectedBanks())
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setIsSubmitting(false)
      setActive(3);
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: parseErrorMessage(err?.response?.data?.message || err.message),
        },
      });
      if (err?.response?.data?.data?.data) {
        // check if its a conflict
        if (err?.response?.data?.data?.isConflict) {
          setIsConflict(true)
        } else {
          setErrors(err?.response?.data?.data?.data)
        };
      } else if (err?.response?.data?.data) {
        setCustomErrors(err?.response?.data?.data);
      }
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        activity: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        meta: {
          error: err?.response?.data?.message || err.message
        }
      });
    }
  };


  const handleBackToHome = () => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      activity: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      meta: {
        country,
        currency,
        fiatService,
        mode
      }
    });
    navigate('/home');
  }
  if (!displayForm || loading || !bankForm || !vendorStatus) {
    return <AppScreenLoader />;
  }
  if (isComplete || ACTIVITY_STATUS.pending.indexOf(vendorStatus?.status) > -1) {
    return (<Box>
      <Typography variant="subtitle2" textAlign={"left"}
        marginBottom={2}
        fontWeight={700}
        sx={{ fontSize: "18px" }}>
        {t('pockyt.paymentMethodThanks')}
      </Typography>
      <Typography variant="subtitle2" textAlign={"left"} sx={{ fontSize: "12px" }}
        marginBottom={2}
      >
        {t('pockyt.paymentMethodThanksDesc')}
      </Typography>

      <Typography variant="subtitle2"
        data-i18n={`[html]pockyt.paymentMethodThanksSupport`}
        textAlign={"left"} sx={{ fontSize: "12px" }}>
        <Trans
          components={{
            a: (
              <Link
                href="mailto:support@rocketfuel.inc"
                target="_blank"
                onClick={() => { }}
              />
            ),
          }}
        >
          {t('pockyt.paymentMethodThanksSupport')}

        </Trans>
      </Typography>
      {saveResponse?.account?.tosLink && <Box>
        <AppPopupWindow
          src={saveResponse?.account?.tosLink}
          title={t('sigin.TnC')}
          show={showTNC}
          setShow={setShowTNC}
          width={500}
          height={700}
        />
      </Box>}
      <AppButton
        onClick={handleBackToHome}
        title={t("goHome")} />

    </Box>
    )
  }

  return (
    <Paper
      ref={containerRef}
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        maxHeight: mode === TRANSFER_MODE ? (isSmallMobile ? '57vh' : '65vh') : 'auto',
        overflowY: mode === TRANSFER_MODE ? "auto" : "none",
        paddingLeft: 1,
        paddingRight: 1,
        paddingBottom: mode === TRANSFER_MODE ? 0 : 5
      }}
    >

      <Grid container marginTop={1} >
        <Grid item xs={12} sm={12}>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"}>
              {!submitFlag ? t("addbank.subtitle1") : t("bank.verification1")}
            </Typography>
          </Slide>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"} marginTop={1}
              data-i18n={`[html]addbank.subtitle2`}>
              <Trans
                components={{
                  a: (
                    <Link
                      href="mailto:support@rocketfuel.inc"
                      target="_blank"
                      onClick={() => { }}
                    />
                  ),
                }}
              >
                {!submitFlag ? t("addbank.subtitle3") : `${t("bank.verification2")}`}
              </Trans>
            </Typography>
          </Slide>

          {!submitFlag && <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography
              variant="subtitle2"
              textAlign={"left"}
              data-i18n={`[html]addbank.subtitle2`}
              marginTop={1}
            >
              <Trans
                components={{
                  a: (
                    <Link
                      href="mailto:support@rocketfuel.inc"
                      target="_blank"
                      onClick={() => { }}
                    />
                  ),
                }}
              >
                {t(`addbank.subtitle2`)}.
              </Trans>
            </Typography>
          </Slide>}
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Box marginTop={2}>
              <Box sx={{ marginTop: 2 }}>
                <Typography
                  fontSize={12}
                  fontFamily={"Manrope"}
                  color={"#FF9494"}
                  textAlign={"right"}
                >
                  * {t("requiredField")}
                </Typography>
              </Box>
              <Formik
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
                enableReinitialize={true}
                validate={async (values) => {
                  const errors = {};
                  for (const key in values) {
                    if (validation[key]) {
                      const isRequired = validation[key].describe().tests.some(
                        (t) => t.name === "required"
                      );

                      if (isRequired && !!values[key]) {
                        try {
                          validation[key].validateSync(values[key], {
                            abortEarly: false,
                          });
                        } catch (err) {
                          err.inner.forEach((error) => {
                            errors[key] = t(error.message);
                          });
                        }
                      }
                    }
                  }
                  return errors;
                }
                }
              >
                {({ handleSubmit, isSubmitting, isValid, errors, values }) => (<>
                  {!preview && <Form onSubmit={handleSubmit} autoComplete="off" style={{ marginBottom: 20 }}>
                    {Object.keys(displayForm).map((key) => (
                      <Box key={key}>
                        {displayForm[key].map((data) => (
                          <Field key={data.name + key} name={data.name + key}>
                            {({ field }) => (
                              <Box key={data.name + key} sx={{
                                  display: [(data.name === 'accountPurposeOther'
                                    && values['accountPurposepersonalDetail'] !== 'Other'
                                  ) ? 'none' : 'unset']
                                }}>
                                  <InputLabel htmlFor={data.name + key} sx={{ marginTop: 1, whiteSpace: 'unset', wordWrap: 'break-word' }}>
                                    {t(`${replaceLabels(data.label)}`)}
                                    {(data.isRequired || (data.name === 'accountPurposeOther'
                                      && values['accountPurposepersonalDetail'] === 'Other'
                                    )) && (
                                        <sup style={{ color: "#FF9494" }}>*</sup>
                                      )}
                                    {(data?.caption || data.name === "Address1") && <Typography
                                      color="#DDDDDD"
                                      fontSize={12}
                                      textOverflow="clip"
                                      overflow="visible"
                                      sx={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                      }}
                                    >
                                      {data.caption || t("bankForm.address1.rules")}
                                    </Typography>}
                                  </InputLabel>
                                  {(data.type !== 'select' && data.type !== 'date' && data.type !== 'image' && data.type !== 'date-month' && data.type !== 'radio' && data.type !== 'link') && (
                                    <FormControl
                                      fullWidth
                                      variant="outlined"
                                      required={data.isRequired || (data.name === 'accountPurposeOther'
                                        && values['accountPurposepersonalDetail'] === 'Other'
                                      )}
                                      disabled={!data.isEditable}
                                    >
                                      <OutlinedInput
                                        {...field}
                                        id={data.name + key}
                                        label={t(`${data.label}`)}
                                        placeholder={data.placeholder || (data.name === "Address1" ? t("bankForm.address1.placeholder") : "")}
                                        autoComplete="off"
                                      />
                                    </FormControl>
                                  )}
                                  {
                                    (data.type === 'link') && <Box>
                                      <Link href={data?.link} target="_blank" rel="noopener" sx={{ fontSize: 14 }}>
                                        {data?.linkCaption} <ArrowOutward style={{ marginBottom: -5 }} />
                                      </Link>
                                      <Typography fontSize={12} marginTop={2}>{data?.caption2}</Typography>
                                    </Box>
                                  }
                                  {
                                    (data.type === 'date') &&
                                    <AppDatePicker
                                      {...field}
                                      name={data.name + key}
                                      id={data.name + key}
                                      format={'YYYY-MM-DD'}
                                      required={data.isRequired}
                                      inputProps={{
                                        max: new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD
                                      }}
                                    />
                                  }

                                  {
                                    (data.type === 'date-month') &&
                                    <AppDatePicker
                                      {...field}
                                      custom={true}
                                      name={data.name + key}
                                      id={data.name + key}
                                      format={'YYYY-MM'}
                                      required={data.isRequired}
                                    />
                                  }

                                  {data.type === 'radio' &&
                                    <RadioGroup
                                      {...field}
                                      value={field.value || data?.acceptedValues?.[0] || ""}
                                      aria-labelledby={`${data.name + key}-label`}
                                      name={data.name + key}
                                      id={data.name + key}
                                      label={t(`${data.label}`)}
                                    >
                                      {data?.acceptedValues?.map((v, index) => (<FormControlLabel key={index} value={v} control={<Radio />} label={v} />))}
                                    </RadioGroup>}
                                  {(data.type === 'select') &&
                                    <AppSearchSelect
                                      field={field}
                                      data={data}
                                      key={key}
                                      t={t}
                                      errorMessage={(() => {
                                        const errorMessage = errors?.[data.name + key] || getCustomErrorMessage(customErrors, data);
                                        return errorMessage ? errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1) : "";
                                      })()}
                                      disabled={!data.isEditable}
                                      required={data.isRequired}
                                      label={t(`${replaceLabels(data.label)}`)}
                                      placeholder={data.placeholder || ''}
                                      acceptedValues={data.acceptedValues || []}
                                      value={field.value}
                                      onChange={field.onChange}
                                      onBlur={field.onBlur}
                                      name={data.name + key}
                                      id={data.name + key}
                                    />
                                  }

                                  {(data.type === 'image') && (
                                    <FormControl
                                      fullWidth
                                      variant="outlined"
                                      required={data.isRequired}
                                      disabled={!data.isEditable}
                                    >
                                      <ImageUploader
                                        {...field}
                                        required={data.isRequired}
                                        disabled={!data.isEditable}
                                        name={data.name + key} id={data.name + key} value={values[data.name + key]} />
                                    </FormControl>
                                  )}
                                  {(data.type !== 'select') && (
                                    <FormHelperText
                                      sx={{ color: "#FF9494", fontSize: 12 }}
                                    >
                                      {(() => {
                                        const errorMessage = errors?.[data.name + key] || getCustomErrorMessage(customErrors, data);
                                        return errorMessage ? errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1) : "";
                                      })()}
                                    </FormHelperText>
                                  )}
                                </Box>
                            )}
                              </Field>
                            ))}
                          </Box>
                        ))}
                        <Box marginTop={2}></Box>
                        {!kycNeeded && <AppButton onClick={() => setPreview(true)} title="Preview All Details"
                          buttontheme="light" sx={{ height: 30, fontSize: 12, width: 180, margin: 'auto' }} />}
                        {!kycNeeded && <AppButton
                          type="submit"
                          disabled={!isValid || isSubmitting || !!kycNeeded}
                          loading={isSubmitting}

                          title={submitFlag ? t("Submit") : t("loginPage.continue")}
                          sx={{ marginTop: 3 }}
                        />}
                        {!!kycNeeded && <AppButton
                          loading={refetchingKyc}
                          disabled={refetchingKyc}
                          onClick={() => { setRefetchingKyc(true); dispatch(getPockytBankFormData(currency.id, country.iso2, destinationRecord?.destinationRecordId, handleSuccessFormFetch, handleFetchFormError)) }}
                          title={t("loginPage.continue")}
                          sx={{ marginTop: 3 }}
                        />
                        }
                      </Form>}
                    {preview && <AppPreviewFormData formData={values} bankForm={Object.values(bankForm).flat().filter(v => !!v)} />}
                    {(preview) && <AppButton onClick={() => setPreview(false)} title="Close Preview"
                      buttontheme="light" sx={{ height: 30, fontSize: 12, width: 180, margin: 'auto' }} />}
                  </>)}
                </Formik>
            </Box>
          </Slide>
        </Grid>
      </Grid>
      {!preview && <Typography marginTop={1}>
        {t('bankDesclaimer')}
      </Typography>}
      {/* </Zoom> */}
    </Paper>
  );
}

PaymentForm.propTypes = {
  paymentMethod: PropTypes.object,
  paymentCurrency: PropTypes.string,
  editValue: PropTypes.object,
  setActive: PropTypes.func,
  active: PropTypes.number,
  newMode: PropTypes.bool,
  disableNewMode: PropTypes.func,
};
